import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Command, CommandCreate, CommandUpdate, Device, Template, TemplateCreate, TemplateUpdate } from '../../../shared/interfaces/click.interfaces';

export const ClickActions = createActionGroup({
  source: 'Click',
  events: {
    'Search Device': props<{ email: string }>(),
    'Search Device Success': props<{ data: Device }>(),

    'Load Commands': emptyProps(),
    'Load Commands Success': props<{ data: Command[] }>(),

    'Create Command': props<{ payload: CommandCreate }>(),
    'Create Command Success': props<{ data: Command }>(),

    'Update Command': props<{ payload: CommandUpdate }>(),
    'Update Command Success': props<{ data: Command }>(),

    'Load Command By Id': props<{ id: number }>(),
    'Load Command By Id Success': props<{ data: Command }>(),

    'Unset Selected Command': emptyProps(),

    'Delete Command': props<{ id: number }>(),

    'Load Templates': emptyProps(),
    'Load Templates Success': props<{ data: Template[] }>(),

    'Create Template': props<{ payload: TemplateCreate }>(),
    'Create Template Success': props<{ data: Template }>(),

    'Update Template': props<{ payload: TemplateUpdate }>(),
    'Update Template Success': props<{ data: Template }>(),

    'Load Template By Id': props<{ id: number }>(),
    'Load Template By Id Success': props<{ data: Template }>(),

    'Unset Selected Template': emptyProps(),

    'Delete Template': props<{ id: number }>(),

    'Add Command': props<{ commandId: number, templateId: number }>(),
    'Add Command Success': props<{ data: Template }>(),

    'Remove Command': props<{ commandId: number, templateId: number }>(),
    'Remove Command Success': props<{ data: Template }>(),

    'Add Notification': props<{ eventDefinitionId: number, templateId: number }>(),
    'Add Notification Success': props<{ data: Template }>(),

    'Remove Notification': props<{ eventDefinitionId: number, templateId: number }>(),
    'Remove Notification Success': props<{ data: Template }>(),

    'Unset Click Store': emptyProps(),
  }
});
